<template>
    <label
        class="common-file-loader-2"
        v-on:drop.stop.prevent="onFileChange"
        v-on:dragover.prevent
        v-bind:class="{
            _loaded: isLoaded,
            _loading: isLoading,
            _error: error !== null,
        }"
        v-bind:for="inputId"
    >
        <div
            class="common-file-loader-2__loader"
            v-bind:class="{
                _instant: file === null,
            }"
            v-bind:style="loaderStyle"
        />
        <div class="common-file-loader-2__info" v-on:click="open">
            <div class="common-file-loader-2__info-content">
                <div
                    class="common-file-loader-2__info-icon"
                    v-bind:class="{ '_done': file, '_error': error }"
                >
                    <icon
                        v-bind:name="file ? 'upload-file-done' : 'upload-file'"
                        width="14"
                        height="18"
                        v-if="!isLoading"
                    />
                    <ui-loader v-else />
                </div>
                <div class="common-file-loader-2__info-text">
                    <div
                        class="common-file-loader-2__info-text-title"
                        v-bind:class="{ '_error': error }"
                    >
                        {{ title }}<span v-if="required" class="_required">*</span>
                    </div>
                    <div
                        class="common-file-loader-2__info-text-description"
                        v-bind:class="{ '_error': error }"
                        v-text="status"
                        v-if="status"
                    />
                </div>
            </div>
            <div class="common-file-loader-2__info-buttons">
                <ui-button
                    v-bind:disabled="isLoading"
                    text="Выбрать файл"
                    theme="secondary"
                    size="sm"
                    v-if="!file"
                />
                <div
                    class="common-file-loader-2__info-icon"
                    v-on:click.stop="deletePhoto"
                    v-else
                >
                    <icon name="trash" width="16" height="16" color="#000" />
                </div>
            </div>
        </div>
        <input
            class="common-file-loader-2__input"
            v-bind:id="inputId"
            type="file"
            v-on:change="onFileChange"
            v-bind:disabled="isLoading"
            ref="input"
            v-if="!file"
        />
        <!-- accept=".jpg, .jpeg, .png, .pdf" -->
    </label>
</template>

<script>
export default {
    name: 'common-file-loader-2',
    props: {
        title: {
            type: String,
            default: 'Загрузить файл',
        },
        description: {
            type: String,
            default: '',
        },
        file: {
            type: [ File, String ],
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        givenError: {
            type: String,
            default: null,
        },
        progress: {
            type: Number,
            default: 0,
        },
        limit: {
            type: Number,
            default: 8, // 8 Mb
        },
        required: Boolean,
    },
    model: {
        prop: 'file',
        event: 'change',
    },
    data: () => ({
        // validFileTypes: [ 'image/jpeg', 'image/pjpeg', 'image/png', 'application/pdf' ],
        validFileTypes: [],
        internalError: null,
        imageTempSrc: null,
    }),
    computed: {
        loaderStyle() {
            return { transform: `translateX(${this.progress - 100}%)` };
        },
        status() {
            if (this.error) {
                return this.error;
            } else if (this.isLoading) {
                return 'Загружается...';
            } else if (this.file && this.file.filename_short) {
                return this.file.filename_short;
            } else {
                return this.description;
                // return `${(this.file.size / 1024 / 1024).toFixed(1)} Мб, загружено`;
            }
        },
        error() {
            return this.internalError || this.givenError || null;
        },
        isLoaded() {
            return !this.error && !this.isLoading && this.file !== null;
        },
        inputId() {
            return 'upload-photo-' + this._uid;
        },
    },
    methods: {
        open(e) {
            if (this.file && this.file.image_file) {
                window.open(this.file.image_file, '_blank');
                e.stopPropagation();
            }
        },
        deletePhoto() {
            this.$emit('delete', this.file);
        },
        isValidFileType(file) {
            return this.validFileTypes.length === 0 || this.validFileTypes.indexOf(file.type) > -1;
        },
        onFileChange(e) {
            const files = e.type === 'drop' ? e.dataTransfer?.files : e.target?.files;
            if (files && files.length > 0) {
                this.setImage(files[0]);
            } else {
                this.$emit('change', null);
            }
        },
        async setImage(file) {
            this.internalError = null;
            this.imageTempSrc = null;
            if (!this.isValidFileType(file)) {
                this.internalError = `Файл ${file.name} имеет недопустимый тип (поддерживаются jpg, png, pdf)`;
                return;
            }
            if (file.size > this.limit * 1024 * 1024) {
                this.internalError = `Файл ${file.name} превышает допустимый размер (лимит ${this.limit} Мб)`;
                return;
            }
            this.$emit('change', file);
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-file-loader-2 {
    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: @border-radius-md;
    border: 1px dashed currentColor;
    overflow: hidden;

    color: @color-gray-main;

    background-color: @color-gray-lighter;

    cursor: pointer;
    // &._error,
    &._loaded {
        border-style: solid;
    }
    &._loaded {
        border-style: solid;
        border-color: @color-gray-light-secondary;
    }
    &._error &,
    &._loaded & {
        &__icon {
             // font-size: 3.2rem;
        }
    }
    &._error {
        color: @color-accent-negative;

        // background-color: fade(@color-accent-negative, 10%);
    }
    &._loading {
        pointer-events: none;
    }
    &._loaded {
        color: @color-primary;
    }
    &__loader {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        background-color: fade(@color-gray-main, 10%);

        transition: transform @duration-normal @easing-default, background-color @duration-fast @easing-default;
        &._instant {
            transition-duration: 0s;
        }
        ._loaded > & {
            background-color: fade(@color-primary, 10%);
        }
    }
    &__info {
        display: flex;
        align-items: center;
        gap: 12px;

        position: relative;
        z-index: 1;

        width: 100%;
        height: 100%;
        // padding: 12px 48px 12px 16px;
        padding: 16px;

        &-content {
            display: flex;
            align-items: center;
            gap: 12px;
            flex: 1;
        }
        &-buttons {
            color: @color-primary;
        }
        &-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            color: @color-gray-darker;

            &._error {
                color: @color-accent-negative;
            }
            &._done {
                color: @color-positive;
            }
        }
        &-text {
            display: flex;
            flex-direction: column;
            gap: 4px;

            &-title {
                .typography-body();

                color: @color-gray-darker;
                // text-overflow: ellipsis;
                // overflow: hidden;
                // white-space: nowrap;
                &._error {
                    color: @color-accent-negative;
                }
                & ._required {
                    color: @color-accent-negative;
                    padding-left: 2px;
                }
            }
            &-description {
                .typography-caption();

                color: @color-gray-main;

                &._error {
                    color: @color-accent-negative;
                }
            }
        }
        &-remove {
            position: absolute;
            top: 6px;
            right: 0;

            padding: 16px;

            font-size: 1.6rem;

            cursor: pointer;
        }
    }
    &__input {
        position: absolute;
        z-index: -1;

        opacity: 0;
    }
    @media @media-sm-down {
        &__info {
            flex-direction: column;
            align-items: flex-start;
        }
    }
}
</style>
